import React from "react";
import { Breadcrumb } from "semantic-ui-react";
import styles from "./CheckoutProgress.module.scss";
const breadcrumbs = ["home", "cart", "payment", "checkout"];

const CheckoutProgress = ({ active }: { active: string }) => {
  return (
    <Breadcrumb className={styles.self}>
      {breadcrumbs.map((crumb: string) => (
        <React.Fragment key={`${crumb}`}>
          <Breadcrumb.Section active={active === crumb}>
            {crumb}
          </Breadcrumb.Section>
          <Breadcrumb.Divider />
        </React.Fragment>
      ))}
    </Breadcrumb>
  );
};

export default CheckoutProgress;
